import React from "react";
import { connect } from "react-redux";
import {
    Container,
    Grid,
    Typography, AppBar, Toolbar, Table, TableBody, TableRow, TableCell, 
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { withTranslation } from 'react-i18next';
import { NumericFormat } from "react-number-format";
import { formatDate, authHeader } from "../../_helpers";
import { flushSync } from "react-dom";

const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar: {
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0)
        }
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing(5, 0, 6),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(0)
        }
    },
    innerContainer: {
        padding: theme.spacing(2, 3, 4)
    },
    bigAvatar: {
        margin: 'auto',
        width: 120,
        height: 120
    },
    halfWidth: {
        width: '50%'
    },
    button: {
        '&:hover': {
            color: theme.palette.primary.contrastText
        }
    }
});


class Page extends React.Component {
    state = {
        building: null
    };

    componentDidMount() {
        this.UpdateBuildingInfo();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.selected || prevProps.selected.buildingId !== this.props.selected.buildingId) {
            this.UpdateBuildingInfo();
        }
    }

    UpdateBuildingInfo() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/home/GetBuildingInfo/' + encodeURI(selected.buildingId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

           flushSync(()=>{
             this.setState({
                building: null,
            });
           })

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                   flushSync(()=>{ this.setState({ building: findResponse });})
                });
        }
    }

    render() {
        const { t, classes, currencySymbol } = this.props;
        const { building } = this.state;
        return (
            (<Container className={classes.mainContainer}>
                <Grid container>
                    <Grid container className={classes.container} size={{xs:12}}>
                        <AppBar position="sticky" color='inherit' className={classes.appBar}>
                            <Toolbar variant="dense">
                                <Typography className={classes.bold}>{t('layout.menuitem.projectinformation.myhouse')}</Typography>
                            </Toolbar>
                        </AppBar>
                        {
                            building &&
                            <Grid
                                container
                                spacing={2}
                                className={classes.innerContainer}
                                sx={{
                                    alignItems: "flex-start"
                                }}
                                size={{xs:12}}>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <Typography variant="h6">{t('general.generalInformation')}</Typography>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                    {t('general.buildingNumber.external') + ':'}
                                                </TableCell>
                                                <TableCell>{building.buildingNoExtern && building.buildingNoExtern}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.homeType') + ':'}
                                                </TableCell>
                                                <TableCell>{building.propertyType && building.propertyType}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.type') + ':'}
                                                </TableCell>
                                                <TableCell>{building.buildingType && building.buildingType}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('buyersGuide.freeInNamePrice') + ':'}
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        building.freeInNamePriceInclVAT &&
                                                        <NumericFormat
                                                            prefix={`${currencySymbol} `}
                                                            displayType="text"
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            value={building.freeInNamePriceInclVAT}
                                                        />
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <Typography variant="h6">{t('layout.navbar.address')}</Typography>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                    {t('general.streetAndHouseNumber') + ':'}
                                                </TableCell>
                                                <TableCell>{building.street && building.street}&nbsp;{building.houseNo && building.houseNo}{building.houseNoAddition && building.houseNoAddition}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.address.postcode') + ':'}
                                                </TableCell>
                                                <TableCell>{building.postcode && building.postcode}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.address.city') + ':'}
                                                </TableCell>
                                                <TableCell>{building.place && building.place}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>

                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <Typography variant="h6">{t('buyersGuide.energy')}</Typography>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                    {t('general.eanCodeElectricity') + ':'}
                                                </TableCell>
                                                <TableCell>{building.eanElectricity && building.eanElectricity}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.eanCodeGas') + ':'}
                                                </TableCell>
                                                <TableCell>{building.eanGas && building.eanGas}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>

                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <Typography variant="h6">{t('general.warranty')}</Typography>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell component="th" scope="row" className={classes.halfWidth}>
                                                    {t('general.warrantyScheme') + ':'}
                                                </TableCell>
                                                <TableCell>{building.guaranteeScheme && building.guaranteeScheme}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('general.endOfMaintenancePeriod') + ':'}
                                                </TableCell>
                                                <TableCell>{building.dateEndMaintenancePeriod && formatDate(new Date(building.dateEndMaintenancePeriod))}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('buyersGuide.warrantyCertificateNumber') + ':'}
                                                </TableCell>
                                                <TableCell>{building.guaranteeCertNo && building.guaranteeCertNo}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('buyersGuide.validFrom') + ':'}
                                                </TableCell>
                                                <TableCell>{building.guaranteeCertValidFrom && formatDate(new Date(building.guaranteeCertValidFrom))}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {t('buyersGuide.validTo') + ':'}
                                                </TableCell>
                                                <TableCell>{building.guaranteeCertValidUntil && formatDate(new Date(building.guaranteeCertValidUntil))}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Container>)
        );
    }
}

function mapStateToProps(state) {
    const { authentication, buildings, appConfig } = state;
    const { user } = authentication;
    const { selected } = buildings;
    const { currencySymbol } = appConfig || {};

    return {
        user,
        selected,
        currencySymbol
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as MyHomePage };